import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TeamRoleStateChip',
  props: {
    state: null
  },
  setup(__props: any) {



const getRecordIcon = (state: string) => {
  const map: Record<string, string> = {
    published: "rocket",
    unpublished: "clock-circle",
    filled: "check-circle",
  }

  return map[state] || "record"
}

return { __sfc: true,getRecordIcon }
}

})